import { render } from "./wdm_add_to_basket.vue?vue&type=template&id=373d3e54"
import script from "./wdm_add_to_basket.vue?vue&type=script&lang=js"
export * from "./wdm_add_to_basket.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__